export default function About() {
  return (
    <section id="about" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3">
            <p className="text-sm font-semibold text-gray-600 tracking-wider uppercase mb-4">ABOUT US</p>
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              25 Years of Crafting Dream Spaces
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-8 max-w-2xl">
              Mt Zion Renovation has been transforming commercial and residential spaces since 1998. Our team of skilled craftsmen and designers bring decades of combined experience to every project, ensuring exceptional quality and attention to detail that exceeds expectations.
            </p>
            <p className="text-base text-gray-600 leading-relaxed mb-10 max-w-2xl">
              We believe that your space should reflect your unique vision and meet your specific needs. From initial consultation to final walkthrough, we work closely with you to bring your vision to life while maintaining the highest standards of craftsmanship and professionalism.
            </p>

            <div className="grid grid-cols-2 gap-8 mb-10">
              <div>
                <div className="text-5xl font-bold text-gray-900 mb-2">500+</div>
                <p className="text-sm text-gray-600">Projects Completed</p>
              </div>
              <div>
                <div className="text-5xl font-bold text-gray-900 mb-2">98%</div>
                <p className="text-sm text-gray-600">Client Satisfaction</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button className="px-8 py-3 bg-gray-900 text-white text-sm font-semibold rounded-full hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer">
                Our Story
              </button>
              <button className="px-8 py-3 bg-transparent text-gray-900 text-sm font-semibold rounded-full border-2 border-gray-900 hover:bg-gray-900 hover:text-white transition-all whitespace-nowrap cursor-pointer">
                Meet the Team
              </button>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="relative h-[600px] w-full rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/e4a5df940761da7b71822b592889f00e.jpg"
                alt="Our Team"
                className="w-full h-full object-cover object-top grayscale"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
